import { endSearchSession } from '@ms/yammer-data/dist/domains/searchSession/actions';
import { usePrevious } from '@ms/yammer-web-core-ui/dist/util/usePrevious';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useLocationSearchText } from '../search/useLocationSearchText';

export const useEndSearchSessionEffect = () => {
  const searchText = useLocationSearchText();
  const previous = usePrevious(searchText);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!searchText && !!previous) {
      dispatch(endSearchSession());
    }
  }, [searchText, previous, dispatch]);
};
